<template>
  <section class="maintenance-page">
    <div class="content">
      <img src="@/assets/img/public/BEATDAY_AlternateLogo_Multicolor.svg" alt="" class="BEATDAY-logo" />
      <h1 v-if="maintenanceType === MaintenanceType.GLOBAL">
        {{ $t('maintenance.key001') }}
      </h1>
      <h1 v-else-if="maintenanceType === MaintenanceType.STREAMING">
        {{ $t('maintenance.key005') }}
      </h1>
      <p v-if="isDisplayTimeShow">
        {{ $t('maintenance.key003') }}<span>{{ time }}</span>
      </p>
      <div class="announcement-box" v-if="isAnnouncementBoxShow">
        <h2>{{ announcementTitle }}</h2>
        <p>{{ announcementContent }}</p>
      </div>
      <button @click="refreshPage">{{ $t('maintenance.key004') }}</button>
    </div>
    <div class="img-box">
      <img src="../assets/img/public/Line_QRcode_Big.svg" class="qrcode-image" />
    </div>
  </section>
</template>

<script>
import store from '@/vuex';
import { formatTimeRange } from '@/utils/formatTimeRange';

export const MaintenanceType = Object.freeze({
  GLOBAL: 'global', // 全站維護
  STREAMING: 'streaming', // 直播間維護
});

export default {
  name: 'MaintenancePage',
  components: {},
  props: {
    statusData: {
      type: Object,
      required: true,
    },
    maintenanceType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      MaintenanceType,
      time: '',
      announcementTitle: '',
      announcementContent: '',
      isAnnouncementBoxShow: false,
      isDisplayTimeShow: false,
    };
  },
  watch: {
    statusData: {
      handler(newVal) {
        if (newVal) {
          this.handleWebStatus(newVal);
        }
      },
      immediate: true,
    },
  },
  methods: {
    refreshPage() {
      window.location.reload();
    },
    async handleWebStatus(response) {
      try {
        const startTimeItem = response.startTime;
        const endTimeItem = response.endTime;
        if (startTimeItem && endTimeItem) {
          this.time = formatTimeRange(startTimeItem, endTimeItem, false, true);
          this.isDisplayTimeShow = true;
        }

        const langSetting = store.state.currentLanguage === 'zh_tw' ? 'zh-tw' : store.state.currentLanguage;
        const findLang = (arr) => {
          return arr.find((item) => item.language === langSetting) || arr.find((item) => item.language === 'zh-tw');
        };

        const titleItem = findLang(response.announcementTitle);
        const contentItem = findLang(response.announcementContent);
        if (titleItem && contentItem) {
          this.announcementTitle = titleItem.value;
          this.announcementContent = contentItem.value;
          this.isAnnouncementBoxShow = true;
        }
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/styles/pages/maintenancePage.scss';
</style>
